import * as React from "react";
import TextInput, {TextInputProps} from "./TextInput";

const EmailInput: React.FC<TextInputProps> = (props) => {
  return (
    <TextInput
      {...props}
      type="email"
      autocomplete="username"
    />
  );
};

export default EmailInput;